
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qu’en est-il en Suisse?`}</em></p>
    <p>{`Il a obtenu le
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/zulassung-covid-19-impfstoff-moderna.html"
      }}>{`feu vert de Swissmedic`}</a>{`
le 12 janvier 2021. Cela en fait le deuxième vaccin approuvé dans notre pays,
après celui de Pfizer/BioNTech. C’est aussi le cheval sur lequel la
Confédération mise le plus: elle en a commandé 13,5 millions de doses pour 2021
et 7 millions pour 2022.`}</p>
    <p>{`Le 9 août 2021, Swissmedic a étendu
l'`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/indikationserweiterung-spikevax-impfstoff.html"
      }}>{`autorisation de ce vaccin aux adolescents de 12 à 17 ans`}</a>{`.`}</p>
    <p>{`Et le 26 octobre,
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/genehmigung-booster-impfung.html"
      }}>{`le feu vert a été donné pour l'utilisation d'un booster`}</a>{`
(troisième dose de rappel) pour les personnes vulnérables. Au stade actuel,
`}<a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/fr/home/das-bag/aktuell/medienmitteilungen.msg-id-85583.html"
      }}>{`l'OFSP et la Commission fédérale pour les vaccinations le recommandent aux plus de 65 ans`}</a>{`,
en particulier ceux qui vivent en EMS ou qui ont d'autres maladies graves.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;